import { createAnalyticsEvent } from 'analytics/create-analytics-event';
import { GAEventName } from 'analytics/ga-event-name.enum';
import { SSFlags } from 'state/context/StatsigContext/StatsigFlags';

export const trueMedBannerLoad = createAnalyticsEvent<{
  date: string;
  location: string;
  shopify_id: string;
  test_variant: string;
}>(({ date, location, shopify_id, test_variant }) => ({
  date,
  event: GAEventName.THANKS_TRUEMED_LOAD,
  location,
  shopify_id,
  test_variant
}));

export const testSimplifiedBaBAnalytics = createAnalyticsEvent<{
  test_variant: string;
}>(({ test_variant }) => ({
  event: GAEventName.TEST_COLLECTION,
  location: 'Build a Bundle',
  test_name: SSFlags.simplifiedBaBexperiment,
  test_variant
}));

export const testHomepageRedesign = createAnalyticsEvent<{
  test_variant: string;
  real_path: string;
}>(({ test_variant, real_path }) => ({
  event: GAEventName.TEST_COLLECTION,
  location: 'Homepage',
  test_name: 'homepage_redesign',
  test_variant,
  real_path
}));
